import { Injectable } from '@angular/core';
import { JobsService as CmbJobsApi, ReasonForCancel, ShiftCancellationRequest } from '@bluecrew/crew-member-backend-angular-client';
import { SegmentCMOSService } from './segment-cmos.service';
import { AnalyticsPlugin } from '@plugins/analytics/analytics-plugin';

@Injectable({
  providedIn: 'root',
})
export class CmosShiftService {
  constructor(private cmbJobsApi: CmbJobsApi, private segmentCMOS: SegmentCMOSService) { }

  async getShiftDetails(jobId: string, shiftId: number) {
    try {
      return await this.cmbJobsApi.getShiftDetails(jobId, shiftId).toPromise();
    } catch (error) {
      AnalyticsPlugin.logEvent({ name: 'getShiftDetails_error', params: { type: typeof error } });
      this.segmentCMOS.addEvent('getShiftDetails_error', {
        reason: error?.error?.reason,
        details: error?.error?.details,
        message: error?.error?.message,
      });
      throw error;
    }
  }

  async confirmShiftTimestamps(externalJobId: string, shiftIndex: number): Promise<any> {
    try {
      return await this.cmbJobsApi.confirmShiftTimestamps(externalJobId, shiftIndex).toPromise();
    } catch (error) {
      AnalyticsPlugin.logEvent({ name: 'confirmShiftTimestamps_error', params: { type: typeof error } });
      this.segmentCMOS.addEvent('confirmShiftTimestamps_error', {
        jobId: externalJobId,
        shiftIndex: shiftIndex,
        reason: error?.error?.reason,
        details: error?.error?.details,
        message: error?.error?.message,
      });
      throw error;
    }
  }

  async getCancellationReasons(jobId: string, shiftIds: number[]) {
    try {
      return await this.cmbJobsApi.getShiftCancellationReasons(jobId, shiftIds).toPromise();
    } catch (error) {
      AnalyticsPlugin.logEvent({ name: 'getShiftCancellationReasons_error', params: { type: typeof error } });
      this.segmentCMOS.addEvent('getShiftCancellationReasons_error', {
        reason: error?.error?.reason,
        details: error?.error?.details,
        message: error?.error?.message,
      });
      throw error;
    }
  }

  async getCancellationPolicies(jobId: string, shiftIds: number[]) {
    try {
      return await this.cmbJobsApi.getShiftCancellationPolicies(jobId, shiftIds).toPromise();
    } catch (error) {
      AnalyticsPlugin.logEvent({ name: 'getShiftCancellationPolicies_error', params: { type: typeof error } });
      this.segmentCMOS.addEvent('getShiftCancellationPolicies_error', {
        reason: error?.error?.reason,
        details: error?.error?.details,
        message: error?.error?.message,
      });
      throw error;
    }
  }

  async cancelSingleShift(jobId: string, shiftId: number, reason: ReasonForCancel) {
    try {
      const request: ShiftCancellationRequest = {
        shiftId,
        reason,
      };
      return await this.cmbJobsApi.cancelShift(jobId, [request]).toPromise();
    } catch (error) {
      AnalyticsPlugin.logEvent({ name: 'cancelShift_error', params: { type: typeof error } });
      this.segmentCMOS.addEvent('cancelShift_error', {
        reason: error?.error?.reason,
        details: error?.error?.details,
        message: error?.error?.message,
      });
      throw error;
    }
  }
}
